import axiosInstance from '../axiosConfigCMS';

export default {
  async getLinks() {
    const response = await axiosInstance.get('/menu-join-links');
    return response.data;
  },
  async getContent() {
    const response = await axiosInstance.get('/menu-join-banners');
    return response.data;
  },
};
